import { lazyLoad } from 'utils/loadable';

export const VerificationSettings = lazyLoad(
  () => import('./index'),
  module => module.VerificationSettings,
);
